import React from 'react';
import {StorageKey} from "../../../../enums/StorageKey";
import {t} from "@lingui/macro";
import Date from "./Cells/Date";
import Number from "./Cells/Number";
import Type from "./Cells/Type";
import ContactName from "bukku/components/Columns/Reports/Common/ContactName";
import Description from "./Cells/Description";
import Amount from "./Cells/Amount";
import AmountBase from "./Cells/AmountBase";
import {AmountTdWidth} from "../../../Table/Common/AmountTd";
import {Helper} from "../../../../containers/AppPage/Reports/Ledger/helper";

function getColumns(props) {
    const { currencyCode, baseCurrencyCode } = props;
    return [
        {
            title: t`Date`,
            key: 'date',
            cellRenderer: ({ rowData: record }) => <Date record={record} />,
            width: 0,
            flexGrow: 16,
        },
        {
            title: t`No.`,
            key: 'number',
            cellRenderer: ({ rowData: record }) => <Number record={record} />,
            width: 0,
            flexGrow: 16,
        },
        {
            title: t`Type`,
            key: 'type',
            cellRenderer: ({ rowData: record }) => <Type record={record} />,
            width: 0,
            flexGrow: 15,
        },
        {
            title: t`Contact`,
            key: 'contact_name',
            cellRenderer: ({ rowData: record }) => (
                <ContactName
                    contact_id={record.contact_id}
                    contact_name={record.contact_name}
                    contact_code={record.contact_code}
                />
            ),
            width: 0,
            flexGrow: 20,
        },
        {
            title: t`Contact Code`,
            key: 'contact_code',
            cellRenderer: Helper.renderContactCode,
            width: 0,
            flexGrow: 15,
        },
        {
            title: t`Description`,
            key: 'description',
            cellRenderer: ({ rowData: record }) => <Description record={record} />,
            width: 0,
            flexGrow: 18,
        },
        {
            title: currencyCode ? t`Amount ${currencyCode}` : t`Amount`,
            key: 'amount',
            align: 'right',
            cellRenderer: ({ rowData: record }) => <Amount record={record} />,
            width: AmountTdWidth,
        },
        {
            title: baseCurrencyCode ? t`Amount ${baseCurrencyCode}` : t`Base Amount`,
            key: 'base_amount',
            align: 'right',
            cellRenderer: ({ rowData: record }) => <AmountBase record={record} />,
            width: AmountTdWidth,
        },
    ];
}

export default {
    storageKey: StorageKey.report_reconciled_transactions,
    getReportLabel: () => t`Reconciled Transactions`,
    required: [
        'date',
        'amount',
    ],
    defaulto: [
        'number',
        'contact_name',
        'description',
    ],
    getColumns,
};
